module.exports = __webpack_public_path__ + "static/media/one_plan_view_academy.27f61bfa.png";